import { OTHER_ORGS } from './abdmCopy';

// Single source of the ABDM "Purpose of Use" list: the consent request form's dropdown AND the
// purpose shown on the consent list row / detail page both read it, so they cannot drift.
//
// Codes: ABDM M3 sandbox docx, "Purpose of Use" table — not in the Postman
// collection (which only shows one worked example, CAREMGT). Labels: cross-checked
// against the actual HL7 v3-PurposeOfUse ValueSet the docx cites as its source
// (https://terminology.hl7.org/.../ValueSet-v3-PurposeOfUse.html) — ABDM's own
// docx transcription differs from HL7 on PATRQT ("Self-Requested" vs HL7's
// "patient requested"); owner R171: show ABDM's own label (the patient sees it in the
// ABHA app). The wire value sent to ABDM is always the code, never this label.
export const PURPOSE_CODES = [
  { value: 'CAREMGT', label: 'Care Management' },
  { value: 'BTG', label: 'Break the Glass' },
  { value: 'PUBHLTH', label: 'Public Health' },
  { value: 'HPAYMT', label: 'Healthcare Payment' },
  { value: 'DSRCH', label: 'Disease Specific Healthcare Research' },
  { value: 'PATRQT', label: OTHER_ORGS.selfRequested },
];

/** Display label for a purpose code; an unknown code is shown as it is; none gives ''. */
export const purposeLabel = (code) => PURPOSE_CODES.find((p) => p.value === code)?.label || code || '';
